import { CircularProgress } from '@mui/material';

export const Loader = (): JSX.Element => (
  <>
    <CircularProgress color="primary" />
  </>
);

export default Loader;
